import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Platform,
  ViewStyle,
} from 'react-native';

export interface DLOCreateScheduleTableActualHeaderProps {
  style?: ViewStyle;
}

const DLOCreateScheduleTableActualHeader: React.FC<DLOCreateScheduleTableActualHeaderProps> = ({
  style,
}) => {
  return (
    <View style={[styles.container, style]}>
      {/* Left section with roles title */}
      <View style={styles.leftSection}>
        <Text style={styles.rolesTitle}>ROLES</Text>
      </View>

      {/* Major divider between ROLES and days */}
      <View style={styles.majorDivider} />

      {/* Days section */}
      <View style={styles.daysSection}>
        {/* Sunday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>SUNDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Monday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>MONDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Tuesday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>TUESDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Wednesday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>WEDNESDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Thursday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>THURSDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Friday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>FRIDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Saturday */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>SATURDAY</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          <View style={[styles.horizontalDivider, styles.dayHorizontalDivider]} />
        </View>
        <View style={styles.majorDayDivider} />

        {/* Total */}
        <View style={styles.dayColumn}>
          <Text style={styles.dayTitle}>TOTAL</Text>
          <View style={styles.subHeaderRow}>
            <Text style={styles.subHeader}>UPREC</Text>
            <Text style={styles.subHeader}>CRW</Text>
          </View>
          {/* Vertical divider between UPREC/ACTUAL */}
          <View style={[styles.verticalDivider, styles.middleDivider]} />
          {/* Horizontal divider for TOTAL column with reduced width */}
          <View style={[styles.horizontalDivider, styles.totalHorizontalDivider]} />
        </View>
      </View>

      {/* Major divider between days and variance */}
      <View style={styles.majorDivider} />

      {/* Variance column */}
      <View style={styles.varianceColumn}>
        <Text style={styles.varianceTitle}>VARIANCE</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 1416,
    height: 88,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#005CBC',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderWidth: 1,
    borderColor: '#005CBC',
  },
  leftSection: {
    width: 227,
    height: 88,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rolesTitle: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 18,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  daysSection: {
    width: 1067,
    height: 88,
    flexDirection: 'row',
    alignItems: 'center',
  },
  dayColumn: {
    width: 132,
    height: 88,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dayTitle: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 32,
    textTransform: 'uppercase',
    textAlign: 'center',
    width: 130, // 100 * 1.3 = 130
    marginTop: 11, // 10 * 1.15 = 11.5 (scaled for 15% increase)
    marginBottom: 20,
  },
  subHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-around', // Changed from space-between to center items better
    alignItems: 'center',
    width: '100%',
    height: 25, // Reduced height as per diff
  },
  subHeader: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 18,
    paddingBottom: 14,
    textTransform: 'uppercase',
    textAlign: 'center',
    width: 48, // 42 * 1.15 = 48.3
    height: 29, // Increased height as per diff
    // Center text both vertically and horizontally
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  varianceColumn: {
    width: 121, // 105 * 1.15 = 120.75
    height: 88, // Updated to match container height
    justifyContent: 'center',
    alignItems: 'center',
  },
  varianceTitle: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 18,
    textTransform: 'uppercase',
    textAlign: 'center',
    marginLeft: -1, // Adjust alignment with major divider
  },
  // Divider styles matching Figma design
  verticalDivider: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    height: 88, // Updated to match container height
    width: 1,
  },
  horizontalDivider: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    height: 1,
  },
  middleDivider: {
    left: 65, // 58 * 1.15 = 66.7 (center divider between UPREC and ACTUAL)
    top: 48, // Updated position as per diff
    height: 40, // Updated height as per diff
  },
  dayHorizontalDivider: {
    width: 131, // 114 * 1.15 = 131.1
    top: 47, // 30 * 1.15 = 34.5 (aligned with middle divider)
    left: 1, // Small left margin to center and prevent overlap
  },
  totalHorizontalDivider: {
    width: 132, // 115 * 1.15 = 132.25
    top: 47, // 30 * 1.15 = 34.5 (aligned with other horizontal dividers)
    left: 1, // Minimal left margin to align with column start
  },
  // Major dividers that span full height
  majorDivider: {
    width: 1,
    height: 88, // Updated to match container height
    backgroundColor: '#FFFFFF',
  },
  majorDayDivider: {
    width: 1,
    height: 88, // Updated to match container height
    backgroundColor: '#FFFFFF',
  },
});

export default DLOCreateScheduleTableActualHeader;
